var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCardDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "rotate(-90 24 24)",
    fill: "#F5F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0005 16.0003C35.0005 15.7445 34.903 15.4883 34.7075 15.2933L32.7075 13.2933C32.3165 12.9023 31.6834 12.9023 31.2934 13.2933L24.0005 20.5863L16.7075 13.2933C16.3165 12.9023 15.6834 12.9023 15.2934 13.2933L13.2934 15.2933C12.9024 15.6843 12.9024 16.3174 13.2934 16.7074L20.5864 24.0003L13.2934 31.2933C12.9024 31.6833 12.9024 32.3174 13.2934 32.7074L15.2934 34.7074C15.6844 35.0984 16.3175 35.0984 16.7075 34.7074L24.0005 27.4144L31.2934 34.7074C31.6834 35.0984 32.3175 35.0984 32.7075 34.7074L34.7075 32.7074C35.0985 32.3164 35.0985 31.6833 34.7075 31.2933L27.4145 24.0003L34.7075 16.7074C34.903 16.5119 35.0005 16.2562 35.0005 16.0003Z",
    fill: "#0071E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCardDetailsIcon);
export default __webpack_public_path__ + "static/media/close-card-details-icon.feaf5594c94e1e1b7d6af66c9024f0e3.svg";
export { ForwardRef as ReactComponent };